import { gql } from "@apollo/client";
import { GraphQLQuery } from "@aws-amplify/api";
import { GetFundsQuery } from "API";
import { useDispatch, useSelector } from "app/hooks";
import { client } from "graphql/client";
import { contributionProducts } from "helpers/products";
import { getMaximumAvailableReportingPeriod } from "helpers/reportingPeriod";
import { useEffect } from "react";
import { investmentFundsActions } from "../../app/features/investmentFunds/investmentFundsSlice";
import { getFunds } from "../../graphql/queries";

export const useInvestmentFunds = () => {
  const dispatch = useDispatch();
  const {
    clientName,
    product,
    hasDrawdown,
    drawdownPercent,
    hasSingle,
    hasRegular,
  } = useSelector((state) => state.investmentDetails);
  const { availableFunds } = useSelector((state) => state.investmentFunds);

  const showLevyMessage =
    ["Synergy Investment Bond (Corporate)", "Synergy Investment Bond"].indexOf(
      product
    ) !== -1;

  const investmentFundsCardDisabled =
    !clientName ||
    !product ||
    (product === "Synergy ARF" && hasDrawdown === undefined) ||
    (contributionProducts.includes(product) && !hasSingle && !hasRegular) ||
    drawdownPercent > 100;

  useEffect(() => {
    const loadFunds = async (): Promise<void> => {
      const { data } = await client.query<GraphQLQuery<GetFundsQuery>>({
        query: gql(getFunds),
        variables: {},
      });
      const funds = data?.getFunds
        ? data.getFunds.map(
            ({ name, citicode, amc, inceptionDate, disabled }: any) => ({
              name,
              citicode,
              amc,
              inceptionDate,
              disabled,
              availableReportingPeriod: getMaximumAvailableReportingPeriod(
                inceptionDate as string
              ),
            })
          )
        : [];
      dispatch(investmentFundsActions.addAllFunds(funds));
    };
    if (!availableFunds) {
      loadFunds();
    }
  }, [dispatch, availableFunds]);

  const isSynergyInvestmentBond = product === "Synergy Investment Bond";
  const isSynergyCorporateBond =
    product === "Synergy Investment Bond (Corporate)";

  return {
    availableFunds,
    investmentFundsCardDisabled,
    showLevyMessage,
    isSynergyInvestmentBond,
    isSynergyCorporateBond,
  };
};
